import { createSlotRecipe } from './runtime.js';

const boxTabConfig = {"name":"boxTab","slots":["root","listWrapper","list","item","handle","label","count","endSlot","panel","scrollButton","scrollDim"],"defaultVariants":{"fill":false,"size":"md"},"variantMap":{"fill":["false","true"],"size":["lg","md","sm"]}}

export const boxTab = /* @__PURE__ */ createSlotRecipe(boxTabConfig)